import React from "react"

import {FieldEditableValueNotEmptyProps} from "../../../../../proto/components/editable/value-not-empty"
import ControlButtonStandard from "../../../../../../gd-components/buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../../../gd-components/buttons/control-button/@types"
import FieldSelectField from "../../select-field"

// const debug = "FieldSelectField_ControlViewNotEmpty"
const debug = false

export default function FieldSelectField_ControlViewNotEmpty(props: FieldEditableValueNotEmptyProps) {

    debug && console.log(debug, 'render', props)

    const field: FieldSelectField = props.field as FieldSelectField

    const showIcon  = _.get(props, 'configOptions.showIcon', true)

    const classes = Classes("p-l-6 p-r-6", props.className)

    const selectedField = field.fields.get(props.value)


    let icon
    if (showIcon) {
        icon = _.get(props.field.components, 'ValueIcon', false)
        if (!icon && selectedField?.icon) {
            icon = <div className={Classes('icon ui5-ico-13 m-r-5', selectedField.icon)}/>
        }
    }

    return (
        <ControlButtonStandard
            className       = {classes}
            size            = {ControlButtonSize.SIZE_28}
            selectedClass   = "hover-bg"
            isSelected      = {true}
            isDisabled      = {props.disabled}
            onClick         = {props.onClick}
        >
            {icon}

            <div className="label txt-truncate ui5-txt-not-important-small">
                {selectedField.label}
            </div>

            {props.children}
        </ControlButtonStandard>
    )
}
